const i = { NotDefined: "Undefined", InOperation: "Enabled", Disconnected: "Disabled", Liquidated: "Liquidated" }, e = { Connecting: "Enable", Disconnecting: "Disable", Audit: "Check", Liquidation: "Liquidate" };
export {
  i as EquipmentStatus,
  e as GasConsumingEquipmentActionType
};
//# sourceMappingURL=types.js.map
